var $6efa0e119f396950$exports = {};
$6efa0e119f396950$exports = {
  "calendar": `\u{41A}\u{430}\u{43B}\u{435}\u{43D}\u{434}\u{430}\u{440}\u{44C}`,
  "day": `\u{434}\u{435}\u{43D}\u{44C}`,
  "dayPeriod": `AM/PM`,
  "endDate": `\u{414}\u{430}\u{442}\u{430} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
  "era": `\u{44D}\u{440}\u{430}`,
  "hour": `\u{447}\u{430}\u{441}`,
  "minute": `\u{43C}\u{438}\u{43D}\u{443}\u{442}\u{430}`,
  "month": `\u{43C}\u{435}\u{441}\u{44F}\u{446}`,
  "second": `\u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}\u{430}`,
  "selectedDateDescription": args => `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{430}\u{44F} \u{434}\u{430}\u{442}\u{430}: ${args.date}`,
  "selectedRangeDescription": args => `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{439} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}: \u{441} ${args.startDate} \u{43F}\u{43E} ${args.endDate}`,
  "selectedTimeDescription": args => `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{43E}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{44F}: ${args.time}`,
  "startDate": `\u{414}\u{430}\u{442}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430}`,
  "timeZoneName": `\u{447}\u{430}\u{441}\u{43E}\u{432}\u{43E}\u{439} \u{43F}\u{43E}\u{44F}\u{441}`,
  "weekday": `\u{434}\u{435}\u{43D}\u{44C} \u{43D}\u{435}\u{434}\u{435}\u{43B}\u{438}`,
  "year": `\u{433}\u{43E}\u{434}`
};
export { $6efa0e119f396950$exports as default };